export default __webpack_public_path__ + "static/media/main-background.3716333e.jpg";